export default {
  Illustrations: 'Ilustraciones',
  Cardiology: 'Cardiología',
  Neurology: 'Neurología',
  Surgery: 'Cirugía',
  Urology: 'Urología',
  Gynecology: 'Ginecología',
  Obstetrics: 'Obstetricia',
  Clinician: 'Clínico',
  Pneumonology: 'Neumonología',
  Endocrinology: 'Endocrinología',
  Orthopedics: 'Ortopedia',
  Pediatrics: 'Pediatría',
  Hematology: 'Hematología',
  Immunology: 'Inmunología',
  Parasitology: 'Parasitología',
  Nutrition: 'Nutrición',
  Odontology: 'Odontología',
  Pharmacy: 'Farmacia',
  Nursing: 'Enfermería',
  Veterinary: 'Veterinario',
  Zoology: 'Zoología',
  Botany: 'Botánica',
  'Cell biology': 'Biología celular',
  Development: 'Desarrollo',
  Entomology: 'Entomología',
  Ornithology: 'Ornitología',
  Biochemistry: 'Bioquímica',
  Chemistry: 'Química',
  Genetics: 'Genética',
  'Molecular Biology': 'Biología molecular',
  Nanotechnology: 'Nanotecnología',
  Neuroscience: 'Neurociencia',
  Pharmacology: 'Farmacología',
  Toxicology: 'Toxicología',
  'Earth Sciences': 'Ciencias de la Tierra',
  Education: 'Educación',
  Engineering: 'Ingeniería',
  Geography: 'Geografía',
  'Physics & Astronomy': 'Física y astronomía',
  Oceanography: 'Oceanografía',
  'Marine biology': 'Biología marina',
  History: 'Historia',
  'Others - Molecular Sciences': 'Otros - Ciencias Moleculares',
  Others: 'Otros',
};
